var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('h1',[_vm._v("Page Not Found")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }